import type { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
import { BlockContentValue } from "@silversea-ssc/ui-components-react";
import clsx from "clsx";
import TextBox from "components/TextBox/TextBox";
import React from "react";
import CruiseExcursionsList, {
  CruiseExcursionsListProps
} from "../CruiseExcursionsList";

import * as styles from "./CruiseItineraryItemDetails.module.scss";

type CruiseItineraryItemDetailsProps = {
  title?: BlockContentValue;
  descriptionOverride?: BlockContentValue;
  description: BlockContentValue;
  excursions?: CruiseExcursionsListProps["excursions"];
  tokenValues?: TokenValues;
  className?: string;
};
const CruiseItineraryItemDetails: React.FC<CruiseItineraryItemDetailsProps> = ({
  title,
  descriptionOverride,
  description,
  excursions,
  tokenValues,
  className
}) => {
  return (
    <div className={styles.wrapper}>
      <div
        className={clsx(
          styles.container,
          {
            [styles.noExcursions]: !excursions?.some((e) => e.items.length > 0)
          },
          className
        )}
      >
        {title && (
          <TextBox
            fontSizeResponsive
            fontSize="medium"
            content={title}
            tokens={tokenValues}
            className={styles.title}
          />
        )}
        {descriptionOverride ? (
          <TextBox
            fontSizeResponsive
            fontSize="medium"
            content={descriptionOverride}
            tokens={tokenValues}
          />
        ) : (
          <TextBox
            fontSizeResponsive
            fontSize="medium"
            content={description}
            tokens={tokenValues}
          />
        )}
      </div>
      {excursions && <CruiseExcursionsList excursions={excursions} />}
    </div>
  );
};

export default CruiseItineraryItemDetails;
